'use client'
import { useQuery } from '@tanstack/react-query'
import { postReview } from '../services'
import { IListPostReviewProps } from '../types/review'

export const usePostReview = ({ productId, params, options }: IListPostReviewProps) => {
  return useQuery({
    queryKey: [postReview.listPostReview({ params, productId })],
    queryFn: () => postReview.get({ params, productId, options }),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
    retry: 2, // Retry failed requests 2 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  })
}
